import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [serverOtp, setServerOtp] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Redirect if already logged in
  useEffect(() => {
    if (sessionStorage.getItem("isAuthenticated") === "true") {
      navigate("/home");
    }
  }, [navigate]);

  const requestOtp = async () => {
    setLoading(true);
    setMessage(""); // Clear previous messages

    try {
      const response = await axios.get("https://stock.hijabsin.com/otp.php");

      console.log("Server Response:", response.data); // Debugging

      if (response.data.status === "success") {
        setServerOtp(response.data.otp);
        setMessage("OTP has been sent to your email.");
      } else {
        setMessage("Failed to send OTP. Try again.");
      }
    } catch (error) {
      console.error("Error requesting OTP:", error);
      setMessage("Server error. Try again later.");
    }
    setLoading(false);
  };

  const handleLogin = () => {
    if (!otp) {
      setMessage("Please enter the OTP.");
      return;
    }

    if (parseInt(otp, 10) === serverOtp) {
      sessionStorage.setItem("isAuthenticated", "true"); // Store in sessionStorage
      navigate("/home");
    } else {
      setMessage("Incorrect OTP. Try again.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f3f4f6",
      }}
    >
      <div
        style={{
          backgroundColor: "#ffffff",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          padding: "32px",
          width: "400px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: "600",
            marginBottom: "16px",
          }}
        >
          Admin Login
        </h2>

        <button
          onClick={requestOtp}
          disabled={loading}
          style={{
            width: "100%",
            backgroundColor: loading ? "#4b5563" : "#2563eb",
            color: "#ffffff",
            padding: "10px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            marginBottom: "16px",
            opacity: loading ? 0.5 : 1,
          }}
        >
          {loading ? "Requesting..." : "Request Code"}
        </button>

        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder="Enter OTP"
          style={{
            width: "100%",
            border: "1px solid #d1d5db",
            borderRadius: "6px",
            padding: "10px",
            marginBottom: "16px",
            outline: "none",
          }}
        />

        <button
          onClick={handleLogin}
          style={{
            width: "100%",
            backgroundColor: otp ? "#059669" : "#6b7280",
            color: "#ffffff",
            padding: "10px",
            borderRadius: "6px",
            border: "none",
            cursor: otp ? "pointer" : "not-allowed",
            opacity: otp ? 1 : 0.5,
          }}
          disabled={!otp} // Disable login button if OTP is empty
        >
          Login
        </button>

        {message && (
          <p
            style={{
              color: "#dc2626",
              marginTop: "16px",
              fontSize: "0.875rem",
            }}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default Login;
